/* SALE menu: in-place accordion inside the mobile drawer.

   The theme's own delegated handlers turn any parent item into a slide-in
   child panel. For the SALE item we intercept the click on document in the
   capture phase (so it never reaches those handlers) and toggle a class the
   sale-menu.css accordion reacts to. Desktop is untouched.
*/
(function () {
  document.addEventListener(
    'click',
    (evt) => {
      const drawer = evt.target.closest && evt.target.closest('.mobile-navigation-drawer');
      if (!drawer) return;
      const item = evt.target.closest('.navigation__item--sale-custom');
      if (!item) return;
      // Only the item's own row toggles; links inside the submenu must navigate.
      const inSubmenu = evt.target.closest('.navigation__tier-2-container');
      if (inSubmenu) return;

      evt.preventDefault();
      evt.stopPropagation();
      item.classList.toggle('navigation__item--sale-open');
    },
    true
  );
})();
